import { render, staticRenderFns } from "./NavBarRoot.vue?vue&type=template&id=6c29247b&scoped=true&"
import script from "./NavBarRoot.vue?vue&type=script&lang=js&"
export * from "./NavBarRoot.vue?vue&type=script&lang=js&"
import style0 from "./NavBarRoot.vue?vue&type=style&index=0&id=6c29247b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c29247b",
  null
  
)

export default component.exports